import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminStores from "@/pages/admin/AdminStores";
import AdminSettings from "@/pages/admin/AdminSettings";
import SuperStats from "@/pages/admin/SuperStats";
import SuperRegie from "@/pages/admin/SuperRegie";
import SuperRegieOrganicVisitors from "@/pages/admin/SuperRegieOrganicVisitors";
import SuperActivity from "@/pages/admin/SuperActivity";
import SuperStripe from "@/pages/admin/SuperStripe";
import SuperSeo from "@/pages/admin/SuperSeo";
import SuperCommunication from "@/pages/admin/SuperCommunication";
import SuperBackup from "@/pages/admin/SuperBackup";
import AdminRestock from "@/pages/admin/AdminRestock";
import AdminModules from "@/pages/admin/AdminModules";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import AdminAutoBlock from "@/pages/admin/AdminAutoBlock";
import SuperLoyalty from "@/pages/admin/SuperLoyalty";
import SuperLoyaltyCoupons from "@/pages/admin/SuperLoyaltyCoupons";
import BlockedAccount from "@/pages/BlockedAccount";
import AccessBlocked from "@/pages/AccessBlocked";
import ShopSuspended from "@/pages/ShopSuspended";
import AdminSubscription from "@/pages/admin/AdminSubscription";
import SuperSupport from "@/pages/admin/SuperSupport";
import SuperSupportTicket from "@/pages/admin/SuperSupportTicket";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/boutique" element={<Catalog />} />
                <Route path="/categorie/:categorySlug" element={<Catalog />} />
                <Route path="/produit/:slug" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/commande/success" element={<OrderSuccess />} />
                <Route path="/compte" element={<Account />} />
                <Route path="/confidentialite" element={<PrivacyPolicy />} />
              </Route>
              <Route path="/connexion" element={<Login />} />
              <Route path="/inscription" element={<Register />} />
              <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
              <Route path="/reinitialiser-mot-de-passe" element={<ResetPassword />} />
              <Route path="/compte-bloque" element={<BlockedAccount />} />
              <Route path="/acces-refuse" element={<AccessBlocked />} />
              <Route path="/boutique-suspendue" element={<ShopSuspended />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="produits" element={<AdminProducts />} />
                <Route path="commandes" element={<AdminOrders />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="magasins" element={<AdminStores />} />
                <Route path="reglages" element={<AdminSettings />} />
                <Route path="statistiques" element={<SuperStats />} />
                <Route path="regie" element={<SuperRegie />} />
                <Route path="regie/visiteurs-organiques" element={<SuperRegieOrganicVisitors />} />
                <Route path="activite" element={<SuperActivity />} />
                <Route path="stripe" element={<SuperStripe />} />
                <Route path="communication" element={<SuperCommunication />} />
                <Route path="fidelite" element={<SuperLoyalty />} />
                <Route path="fidelite/coupons" element={<SuperLoyaltyCoupons />} />
                <Route path="seo" element={<SuperSeo />} />
                <Route path="sauvegarde" element={<SuperBackup />} />
                <Route path="restock" element={<AdminRestock />} />
                <Route path="utilisateurs" element={<AdminUsers />} />
                <Route path="modules" element={<AdminModules />} />
                <Route path="abonnement" element={<AdminSubscription />} />
                <Route path="securite" element={<AdminSecurity />} />
                <Route path="securite/blocage-automatique" element={<AdminAutoBlock />} />
                <Route path="support" element={<SuperSupport />} />
                <Route path="support/tickets/:ticketId" element={<SuperSupportTicket />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
